export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  imageSeq: string;
  publishedAt: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'butter-game-beginner-guide',
    title: '黄油游戏新手入门完全指南：从零开始的冒险之旅',
    excerpt: '本指南将带领每一位黄油游戏新手从最基础的操作开始，逐步掌握游戏核心玩法、界面导航和初始任务完成技巧，让你在最短时间内融入黄油游戏的精彩世界。',
    content: `<h2>黄油游戏基础操作介绍</h2><p>黄油游戏是一款融合了休闲互动与角色养成的趣味游戏。初次进入游戏时，玩家需要完成基础的新手引导教程，系统会逐步介绍游戏的核心操作界面和基本玩法机制。</p><p>首先，游戏的主界面分为几个重要区域：顶部是角色状态栏，显示当前角色的体力值、金币数量和等级信息；中央是主交互区域，玩家可以在这里与各种游戏元素进行互动；底部是功能导航栏，包含任务、背包、商城和设置等入口。</p><h2>完成初始任务</h2><p>新手阶段，建议优先完成主线任务。主线任务不仅能够帮助玩家熟悉游戏世界，还能获得丰厚的经验值和金币奖励。每天登录还会触发每日任务，完成每日任务是积累资源的重要途径。</p><h2>角色属性系统</h2><p>黄油游戏中每位角色都拥有力量、敏捷、智力、魅力四个基础属性。合理分配属性点对游戏进程至关重要。新手建议优先提升力量属性以确保战斗生存能力，之后再根据个人喜好发展其他属性方向。</p><h2>资源管理技巧</h2><p>金币是游戏中最基础的货币，用于购买道具和装备。玩家可以通过完成任务、击败怪物和参与活动获取金币。建议新手阶段不要随意花费金币，优先积攒用于购买关键装备。</p>`,
    category: 'beginner',
    imageSeq: 'article-beginner-01',
    publishedAt: '2026-08-01',
    readTime: '8分钟',
    tags: ['新手入门', '基础教程', '黄油游戏怎么玩'],
    featured: true,
  },
  {
    id: 'butter-game-character-guide',
    title: '黄油游戏全角色解锁攻略：获取方法与养成路线',
    excerpt: '详细介绍黄油游戏中每一位角色的解锁条件、技能特点、最优养成路线和推荐搭配方案，助你组建最强阵容。',
    content: `<h2>角色系统总览</h2><p>黄油游戏目前拥有多达二十余位可解锁角色，每位角色都拥有独特的背景故事、技能组合和成长路线。角色按照稀有度分为普通、稀有、史诗和传说四个等级。</p><h2>初始角色获取</h2><p>游戏开始时，玩家可以从三位初始角色中选择一位作为伙伴。建议新手选择均衡型角色，以便更好地适应各种战斗场景。初始角色虽然稀有度不高，但经过合理培养，同样能在中后期发挥重要作用。</p><h2>隐藏角色解锁条件</h2><p>黄油游戏中最令人兴奋的莫过于隐藏角色的解锁。这些角色通常需要满足特定条件才能获得，例如：完成特定任务链、达到某些成就、在特定时间段登录游戏等等。我们将逐一揭秘所有隐藏角色的解锁方式。</p><h2>角色养成最佳路线</h2><p>角色养成包括等级提升、技能升级、装备强化和好感度培养四个维度。合理规划资源分配是养成效率最大化的关键。建议集中资源培养2-3名核心角色，避免平均分配导致整体战力不足。</p>`,
    category: 'character',
    imageSeq: 'article-character-01',
    publishedAt: '2026-08-02',
    readTime: '12分钟',
    tags: ['角色攻略', '角色解锁', '养成路线'],
    featured: true,
  },
  {
    id: 'butter-game-hidden-secrets',
    title: '黄油游戏隐藏内容大揭秘：彩蛋、秘密关卡与特殊奖励',
    excerpt: '探索黄油游戏中不为人知的隐藏内容，包括秘密关卡入口、彩蛋触发条件、隐藏对话选项和独家奖励获取方法。',
    content: `<h2>隐藏关卡入口指南</h2><p>黄油游戏中散布着多个隐藏关卡，这些关卡不会在常规地图上显示，需要玩家通过特定的操作或满足隐藏条件才能触发进入。我们通过大量实测验证，确认了所有已知隐藏关卡的入口位置和触发方式。</p><h2>彩蛋触发条件</h2><p>开发团队在游戏中埋藏了大量有趣的彩蛋，从致敬经典的场景还原到令人捧腹的对话文本。触发这些彩蛋通常需要在特定时间、特定地点或进行特定操作才能实现。我们将所有已发现的彩蛋整理成清单，方便玩家逐一体验。</p><h2>隐藏对话选项</h2><p>在与NPC的互动中，部分对话选项默认处于隐藏状态，只有当角色好感度达到一定数值或携带特定道具时才会显示。这些隐藏对话往往能触发特殊事件或解锁额外的剧情内容。</p><h2>特殊奖励攻略</h2><p>游戏中的限时活动、节日庆典和成就系统中隐藏着许多限定奖励。了解这些奖励的获取方式能够让你不错过任何珍贵的收集机会。</p>`,
    category: 'hidden',
    imageSeq: 'article-hidden-01',
    publishedAt: '2026-08-03',
    readTime: '10分钟',
    tags: ['隐藏内容', '彩蛋', '秘密关卡'],
    featured: true,
  },
  {
    id: 'butter-game-advanced-skills',
    title: '黄油游戏进阶技巧大全：高手才知道的十大实战秘籍',
    excerpt: '从战斗连招优化、资源效率最大化到PVP制胜策略，汇总黄油游戏资深玩家的独家进阶技巧。',
    content: `<h2>战斗系统深度解析</h2><p>黄油游戏的战斗系统表面简单，实则蕴含丰富的策略深度。掌握连招取消机制和技能衔接时机是提升战斗效率的关键。高级玩家可以通过精确的时机把控，实现普通攻击与技能之间的无缝衔接，大幅提高输出效率。</p><h2>资源效率最大化</h2><p>在黄油游戏中，体力是最珍贵的资源。合理规划每日体力的使用，优先完成高回报任务和活动，能够让你的成长速度远超普通玩家。此外，金币和道具的使用也需要精打细算，避免不必要的浪费。</p><h2>PVP制胜策略</h2><p>PVP竞技场是检验玩家实力的最佳场所。了解当前版本的角色强度排行、阵容克制关系和战场地形利用，能够帮助你在PVP中取得更高的胜率。不同分段需要采取不同的策略，灵活应变是致胜之道。</p><h2>装备搭配心得</h2><p>装备的选择和搭配直接影响角色的战斗力。不同角色适合不同的装备流派，同样的装备在不同角色身上的效果也可能天差地别。深入了解装备属性和套装效果，才能打造出最适合自己阵容的装备方案。</p>`,
    category: 'advanced',
    imageSeq: 'article-advanced-01',
    publishedAt: '2026-08-04',
    readTime: '15分钟',
    tags: ['进阶技巧', 'PVP攻略', '高手秘籍'],
    featured: true,
  },
  {
    id: 'butter-game-resource-farming',
    title: '黄油游戏资源大全：金币、道具与材料获取效率指南',
    excerpt: '全面整理黄油游戏中所有可获得资源的获取途径、最佳刷取时间和效率对比，帮助玩家实现资源自由。',
    content: `<h2>金币获取全攻略</h2><p>金币是黄油游戏中使用最频繁的货币，获取途径包括日常任务、副本挑战、活动奖励和交易系统。不同获取方式的效率差异很大，了解最优刷金路线能够大幅提升你的金币收益。</p><h2>稀有道具获取</h2><p>稀有道具通常只能通过特定副本、限时活动或者成就奖励获得。我们整理了所有稀有道具的获取条件、掉落概率和推荐刷取策略，帮助你更高效地收集需要的物品。</p><h2>材料收集指南</h2><p>角色突破和装备强化需要大量材料支持。不同的材料分布在游戏的各个区域，了解材料的分布规律和最佳采集路线是高效收集的关键。</p><h2>限时活动资源</h2><p>黄油游戏定期推出的限时活动是获取限定资源的重要渠道。活动期间合理规划时间，优先完成高价值任务，能够获得远超日常的资源回报。</p>`,
    category: 'resource',
    imageSeq: 'article-resource-01',
    publishedAt: '2026-08-05',
    readTime: '9分钟',
    tags: ['资源大全', '金币攻略', '道具获取'],
    featured: true,
  },
  {
    id: 'butter-game-daily-routine',
    title: '黄油游戏每日必做清单：新手每日任务高效完成攻略',
    excerpt: '整理黄油游戏每日必做的任务清单，按照优先级排序，帮助新手玩家高效利用每日有限的游戏时间。',
    content: `<h2>每日任务优先级排序</h2><p>黄油游戏的每日内容非常丰富，但玩家的时间和体力有限。合理规划每日任务顺序，优先完成高回报任务，能够最大化每日收益。</p><h2>每日签到与登录奖励</h2><p>坚持每日登录是最基础也是最稳定的资源获取方式。连续签到天数越多，奖励越丰厚。建议将每日登录作为第一优先级任务。</p><h2>每日副本挑战</h2><p>每日副本是获取经验值和基础材料的主要途径。不同副本对应不同的产出类型，根据当前需求选择性地挑战副本能够更高效地利用体力。</p><h2>社交互动任务</h2><p>黄油游戏的社交系统也包含了丰富的奖励内容。好友互助、公会贡献和社区活动都是不容忽视的资源来源。</p>`,
    category: 'beginner',
    imageSeq: 'article-daily-01',
    publishedAt: '2026-08-06',
    readTime: '7分钟',
    tags: ['每日任务', '新手教程', '高效攻略'],
    featured: false,
  },
  {
    id: 'butter-game-team-building',
    title: '黄油游戏阵容搭配推荐：最佳角色组合与战术解析',
    excerpt: '基于当前版本角色强度排行，推荐多套实战验证的最优阵容搭配方案，涵盖PVE推图和PVP竞技两种场景。',
    content: `<h2>阵容搭配基础原则</h2><p>黄油游戏的阵容搭配需要遵循坦克、输出、辅助的铁三角原则。一个平衡的阵容应包含一名能吸收伤害的前排角色、一名高输出的主C角色和一名提供增益或控制的辅助角色。</p><h2>PVE推图推荐阵容</h2><p>PVE推图需要阵容具备持续作战能力和范围伤害输出。推荐的阵容组合能够在保证生存的前提下最大化清图效率。</p><h2>PVP竞技推荐阵容</h2><p>PVP竞技更加注重爆发伤害和控制链的配合。当前版本强势的PVP阵容以速攻流和控制流为主，我们将详细解析每种流派的配置和操作要点。</p><h2>阵容克制关系</h2><p>了解不同阵容之间的克制关系是PVP取胜的关键。火系克制草系、草系克制水系、水系克制火系的元素克制循环是阵容选择的基本参考。</p>`,
    category: 'advanced',
    imageSeq: 'article-team-01',
    publishedAt: '2026-08-06',
    readTime: '11分钟',
    tags: ['阵容搭配', '角色推荐', '战术攻略'],
    featured: false,
  },
  {
    id: 'butter-game-equipment-guide',
    title: '黄油游戏装备强化全攻略：从入门到精通的装备养成指南',
    excerpt: '详细解读黄油游戏装备系统的全部内容，包括装备获取、强化升级、附魔洗练和套装搭配技巧。',
    content: `<h2>装备系统概述</h2><p>黄油游戏的装备系统分为武器、防具、饰品三大类，每种装备都有品质等级和强化等级两个维度。装备品质从低到高依次为白色、绿色、蓝色、紫色和金色。</p><h2>装备获取途径</h2><p>高品质装备主要通过高难度副本掉落、活动奖励和合成系统获得。了解每种装备的最优获取途径，避免在低效方式上浪费时间和资源。</p><h2>装备强化策略</h2><p>装备强化需要消耗强化石和金币，强化等级越高成功率越低。建议前期将装备强化到+7即可，中后期再逐步提升到+10以上。</p><h2>附魔与套装搭配</h2><p>装备附魔可以为装备附加额外的属性加成。套装装备在凑齐指定件数后可以激活强大的套装效果，是提升战力的重要途径。</p>`,
    category: 'resource',
    imageSeq: 'article-equip-01',
    publishedAt: '2026-08-07',
    readTime: '13分钟',
    tags: ['装备强化', '附魔攻略', '套装搭配'],
    featured: false,
  },
  {
    id: 'butter-game-event-calendar',
    title: '黄油游戏2026年度活动日历：限时活动参与攻略',
    excerpt: '整理黄油游戏全年度活动的排期日历，标注重点活动的参与方式和必拿奖励，助你不错过任何福利。',
    content: `<h2>年度活动总览</h2><p>黄油游戏每年都会推出丰富多彩的限时活动，包括春节庆典、夏日嘉年华、周年庆、万圣节派对和冬日祭等大型活动，以及每月的小型主题活动。</p><h2>春节活动攻略</h2><p>春节活动通常是一年中福利最丰厚的活动，包含限定角色、限定皮肤和大量资源奖励。提前了解活动内容和准备策略，能够让你在活动期间收获更多。</p><h2>周年庆活动</h2><p>游戏周年庆期间通常会推出重磅更新内容和回馈活动。这是获取限定物品的最佳时机，建议提前积攒资源以备活动所需。</p><h2>日常活动参与策略</h2><p>除了大型节日活动外，游戏日常的周常活动和月签活动同样不容忽视。将这些活动融入每日的游戏流程中，可以实现收益最大化。</p>`,
    category: 'beginner',
    imageSeq: 'article-event-01',
    publishedAt: '2026-08-07',
    readTime: '10分钟',
    tags: ['活动日历', '限时活动', '福利攻略'],
    featured: false,
  },
];

export const faqItems = [
  {
    question: '黄油游戏怎么玩？新手如何快速上手？',
    answer: '黄油游戏是一款休闲互动类游戏，新手进入游戏后先跟随系统引导完成基础教程，然后按照主线任务逐步推进。建议优先完成每日任务积累资源，同时参考本站的新手入门攻略系列，可以大大缩短上手时间。',
  },
  {
    question: '黄油游戏有哪些隐藏内容可以解锁？',
    answer: '黄油游戏中存在大量隐藏内容，包括隐藏关卡、隐藏角色、彩蛋对话和限定奖励。这些内容通常需要满足特定条件才能触发，例如完成特定任务链、在特定时间登录或达到某些隐藏成就。详细攻略请参考本站隐藏内容专区。',
  },
  {
    question: '黄油游戏角色怎么解锁？有哪些强力角色推荐？',
    answer: '角色解锁方式多种多样，包括完成主线任务获取、参与限时活动兑换、达成成就奖励和特殊条件触发等。新手推荐优先获取均衡型角色，培养到一定程度后再根据阵容需求解锁其他角色。具体解锁条件请查看角色攻略板块。',
  },
  {
    question: '黄油游戏的资源如何高效获取？',
    answer: '资源获取的核心策略是合理规划每日体力分配，优先完成高回报任务和活动。金币主要通过日常任务和副本获得，稀有道具需要参与限时活动或挑战高难度副本，材料则分布在游戏各个区域。完整攻略请参考资源大全板块。',
  },
  {
    question: '黄油游戏适合什么类型的玩家？',
    answer: '黄油游戏适合喜欢休闲互动、角色养成和策略规划的玩家群体。游戏操作门槛较低，画面精美，内容丰富，无论是碎片时间的轻度玩家还是深度策略的游戏爱好者，都能在黄油游戏中找到属于自己的乐趣。',
  },
  {
    question: '黄油游戏有哪些进阶技巧能提升游戏体验？',
    answer: '进阶技巧包括连招取消机制、体力效率最大化规划、PVP阵容克制策略和装备最优搭配方案等。这些技巧需要玩家对游戏机制有较深理解后逐步掌握。本站进阶技巧板块为玩家提供了系统化的高手攻略。',
  },
  {
    question: '黄油游戏的新手教程需要多久才能完成？',
    answer: '黄油游戏的基础新手教程大约需要30-60分钟完成。系统会通过引导任务逐步介绍核心玩法，完成新手教程后即可自由探索游戏世界的各项内容。如果想深入了解游戏深度玩法，建议花费2-3小时浏览本站的新手攻略系列。',
  },
];

export const testimonials = [
  {
    name: '游戏达人小王',
    role: '资深黄油游戏玩家',
    content: '黄油游戏官方指南是我见过最全面的攻略网站，从新手入坑到高手进阶，所有内容都整理得井井有条。靠着这里的攻略，我在一个月内就解锁了所有隐藏角色！',
    rating: 5,
  },
  {
    name: '休闲玩家小李',
    role: '黄油游戏爱好者',
    content: '作为一个每天只有半小时游戏时间的休闲玩家，黄油游戏官方指南的每日必做清单对我帮助特别大，让我在有限时间内也能高效获取资源。',
    rating: 5,
  },
  {
    name: '攻略达人阿陈',
    role: '黄油游戏攻略作者',
    content: '黄油游戏官方指南的内容质量非常高，每篇攻略都经过实战验证，数据准确、条理清晰。作为同行，我非常欣赏这种认真严谨的态度。',
    rating: 5,
  },
  {
    name: '新手玩家小美',
    role: '黄油游戏新晋玩家',
    content: '刚接触黄油游戏时一头雾水，幸好找到了黄油游戏官方指南。新手教程写得特别详细，配图也很清晰，跟着攻略走很快就上手了！',
    rating: 5,
  },
];